// components/Modals/ContentModal/tabs/AutogramSettingsTab.js
import React, { useState, useEffect } from 'react';
import './AutogramSettingsTab.css';
import { toast } from 'react-hot-toast';
import api from '../../../../services/api';

const AutogramSettingsTab = ({
    contentForm,
    setContentForm,
    selectedTagIds,
    setSelectedTagIds,
    tags = [],
    onTagCreated
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTags, setFilteredTags] = useState([]);
    const [isTagsExpanded, setIsTagsExpanded] = useState(true);
    const [showTagInfo, setShowTagInfo] = useState(false);
    const [isCreatingTag, setIsCreatingTag] = useState(false);

    // Etiketleri filtrele - GÜVENLİ VERSİYON
    useEffect(() => {
        // tags array'ini güvenli hale getir
        const safeTags = Array.isArray(tags) ? tags.filter(tag => tag && tag.name) : [];

        let filtered = safeTags;

        if (searchTerm) {
            filtered = filtered.filter(tag =>
                tag.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        setFilteredTags(filtered);
    }, [searchTerm, tags]);

    // Güvenli tags array'i
    const safeTags = Array.isArray(tags) ? tags.filter(tag => tag && tag.name) : [];

    // Aranan etiketin var olup olmadığını kontrol et
    const isExactMatch = searchTerm && safeTags.some(
        tag => tag.name.toLowerCase() === searchTerm.toLowerCase()
    );

    // Yeni etiket oluştur
    const handleCreateTag = async () => {
        if (!searchTerm.trim()) {
            toast.error('Etiket adı boş olamaz');
            return;
        }

        if (isExactMatch) {
            toast.error('Bu isimde bir etiket zaten mevcut');
            return;
        }

        setIsCreatingTag(true);
        try {
            const response = await api.post('/tags', { name: searchTerm.trim() });

            // Backend { success: true, tag: {...} } döndürüyor
            const newTag = response.data.tag || response.data;

            // Eğer tag objesi düzgün gelmezse
            if (!newTag || !newTag.id || !newTag.name) {
                console.error('Geçersiz tag response:', response.data);
                toast.error('Etiket oluşturuldu ancak veri alınamadı');
                return;
            }

            toast.success(`"${newTag.name}" etiketi oluşturuldu`);

            if (onTagCreated) {
                onTagCreated(newTag);
            }

            setSelectedTagIds(prev => [...prev, newTag.id]);
            setSearchTerm('');
        } catch (error) {
            console.error('Etiket oluşturma hatası:', error);
            toast.error(error.response?.data?.error || 'Etiket oluşturulamadı');
        } finally {
            setIsCreatingTag(false);
        }
    };

    // Enter tuşu ile etiket oluştur
    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter' && searchTerm && !isExactMatch && filteredTags.length === 0) {
            e.preventDefault();
            handleCreateTag();
        }
    };

    // Etiket seçimi
    const handleTagToggle = (tagId) => {
        const tagIdNum = parseInt(tagId);

        if (selectedTagIds.includes(tagIdNum)) {
            setSelectedTagIds(selectedTagIds.filter(id => id !== tagIdNum));
        } else {
            setSelectedTagIds([...selectedTagIds, tagIdNum]);
        }
    };

    // Tüm etiketleri seç/kaldır
    const handleSelectAll = () => {
        const safeFilteredTags = filteredTags.filter(tag => tag && tag.id);

        if (safeFilteredTags.length === selectedTagIds.filter(id =>
            safeFilteredTags.some(tag => tag.id === id)
        ).length) {
            setSelectedTagIds(selectedTagIds.filter(id =>
                !safeFilteredTags.some(tag => tag.id === id)
            ));
        } else {
            const newIds = safeFilteredTags.map(tag => tag.id);
            const mergedIds = [...new Set([...selectedTagIds, ...newIds])];
            setSelectedTagIds(mergedIds);
        }
    };

    // Seçili etiketleri temizle
    const handleClearSelection = () => {
        setSelectedTagIds([]);
        toast.success('Tüm etiket seçimleri temizlendi');
    };

    const titleCharCount = contentForm.title?.length || 0;
    const titleMaxLength = 200;
    const selectedCount = selectedTagIds.length;
    const totalCount = safeTags.length;

    const getSelectedTags = () => {
        return safeTags.filter(tag => selectedTagIds.includes(tag.id));
    };

    const getTagColor = (tag) => {
        if (!tag || !tag.name) return '#6B7280';
        const name = tag.name.toLowerCase();
        if (name.includes('youtube')) return '#FF0000';
        if (name.includes('telegram')) return '#0088cc';
        if (name.includes('instagram')) return '#E4405F';
        if (name.includes('tiktok')) return '#000000';
        if (name.includes('twitter') || name.includes('x')) return '#1DA1F2';
        if (name.includes('özel') || name.includes('vip')) return '#FFD700';
        if (name.includes('sabah') || name.includes('akşam')) return '#FF6B6B';
        return '#6B7280';
    };

    const showAddButton = searchTerm && !isExactMatch;

    // Güvenli filteredTags
    const safeFilteredTags = filteredTags.filter(tag => tag && tag.id && tag.name);

    return (
        <div className="ast-autogram-settings-tab">
            <div className="ast-tags-section">
                {/* Başlık Bölümü */}
                <div className="ast-title-section">
                    <div className="ast-section-header">
                        <h4>📝 İçerik Başlığı</h4>
                    </div>

                    <div className="ast-form-group">
                        <input
                            type="text"
                            value={contentForm.title || ''}
                            onChange={(e) => setContentForm({ ...contentForm, title: e.target.value })}
                            placeholder="İçerik başlığını girin..."
                            maxLength={titleMaxLength}
                            className="ast-title-input"
                        />
                        <div className="ast-input-footer">
                            <span className="ast-char-counter">
                                {titleCharCount} / {titleMaxLength}
                            </span>
                            {titleCharCount > 0 && (
                                <span className={`ast-char-status ${titleCharCount > 150 ? 'warning' : ''}`}>
                                    {titleCharCount > 150 ? '⚠️ Uzun başlık' : '✓ Uygun uzunluk'}
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="ast-section-header">
                    <h4>
                        🏷️ Etiketler
                        <span className="ast-tag-count">
                            ({selectedCount}/{totalCount} seçili)
                        </span>
                    </h4>
                    <div className="ast-header-actions">
                        <button
                            type="button"
                            className="ast-action-btn"
                            onClick={() => setShowTagInfo(!showTagInfo)}
                            title="Etiket bilgisi"
                        >
                            ℹ️
                        </button>
                        <button
                            type="button"
                            className="ast-toggle-btn"
                            onClick={() => setIsTagsExpanded(!isTagsExpanded)}
                            title={isTagsExpanded ? 'Bölümü Kapat' : 'Bölümü Aç'}
                        >
                            <svg
                                className={`ast-toggle-icon ${isTagsExpanded ? 'expanded' : ''}`}
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3 4.5L6 7.5L9 4.5"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>

                {showTagInfo && (
                    <div className="ast-info-box">
                        <p>
                            <strong>Etiketler nedir?</strong><br />
                            Etiketler, içeriklerinizi kategorize etmenizi ve otomasyonlarınızda
                            filtreleme yapmanızı sağlar. Birden fazla etiket seçebilirsiniz.
                        </p>
                    </div>
                )}

                {isTagsExpanded && (
                    <>
                        {/* Etiket Araması ve Filtreleme */}
                        <div className="ast-tags-controls">
                            <div className={`ast-search-box ${showAddButton ? 'has-add-btn' : ''}`}>
                                <span className="ast-search-icon">🔍</span>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onKeyDown={handleSearchKeyDown}
                                    placeholder="Etiket ara veya yeni oluştur..."
                                    className="ast-search-input"
                                />
                                {showAddButton && (
                                    <button
                                        type="button"
                                        onClick={handleCreateTag}
                                        disabled={isCreatingTag}
                                        className="ast-add-tag-btn"
                                        title={`"${searchTerm}" etiketini oluştur`}
                                    >
                                        {isCreatingTag ? (
                                            <span className="ast-spinner">⏳</span>
                                        ) : (
                                            <span>+</span>
                                        )}
                                    </button>
                                )}
                            </div>

                            <div className="ast-control-buttons">
                                <button
                                    type="button"
                                    onClick={handleSelectAll}
                                    className="ast-control-btn"
                                >
                                    {safeFilteredTags.length === selectedTagIds.filter(id =>
                                        safeFilteredTags.some(tag => tag.id === id)
                                    ).length ? '☐ Tümünü Kaldır' : '☑ Tümünü Seç'}
                                </button>
                                {selectedCount > 0 && (
                                    <button
                                        type="button"
                                        onClick={handleClearSelection}
                                        className="ast-control-btn clear"
                                    >
                                        🗑️ Temizle
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Yeni etiket oluşturma ipucu */}
                        {showAddButton && safeFilteredTags.length === 0 && (
                            <div className="ast-create-tag-hint">
                                <span>💡</span>
                                <p>
                                    "<strong>{searchTerm}</strong>" bulunamadı.
                                    <button type="button" onClick={handleCreateTag} disabled={isCreatingTag}>
                                        Yeni etiket olarak ekle
                                    </button>
                                </p>
                            </div>
                        )}

                        {/* Seçili Etiketler */}
                        {selectedCount > 0 && (
                            <div className="ast-selected-tags">
                                <h5>Seçili Etiketler:</h5>
                                <div className="ast-selected-tags-list">
                                    {getSelectedTags().map(tag => (
                                        <span
                                            key={tag.id}
                                            className="ast-selected-tag"
                                            style={{
                                                backgroundColor: `${getTagColor(tag)}20`,
                                                borderColor: getTagColor(tag)
                                            }}
                                        >
                                            {tag.name}
                                            <button
                                                type="button"
                                                onClick={() => handleTagToggle(tag.id)}
                                                className="ast-remove-tag"
                                            >
                                                ✕
                                            </button>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Etiket Listesi */}
                        <div className="ast-tags-grid">
                            {safeFilteredTags.length > 0 ? (
                                safeFilteredTags.map(tag => (
                                    <label
                                        key={tag.id}
                                        className={`ast-tag-item ${selectedTagIds.includes(tag.id) ? 'selected' : ''}`}
                                        style={{
                                            borderColor: selectedTagIds.includes(tag.id) ? getTagColor(tag) : '#e5e7eb'
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedTagIds.includes(tag.id)}
                                            onChange={() => handleTagToggle(tag.id)}
                                        />
                                        <span
                                            className="ast-tag-name"
                                            style={{
                                                color: selectedTagIds.includes(tag.id) ? getTagColor(tag) : '#4b5563'
                                            }}
                                        >
                                            {tag.name}
                                        </span>
                                        {tag.count && (
                                            <span className="ast-tag-usage">
                                                {tag.count} kullanım
                                            </span>
                                        )}
                                    </label>
                                ))
                            ) : (
                                !showAddButton && (
                                    <div className="ast-no-tags">
                                        <span>🔍</span>
                                        <p>Etiket bulunamadı</p>
                                    </div>
                                )
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AutogramSettingsTab;